// extracted by mini-css-extract-plugin
module.exports = {"movieCard":"movieCard_movieCard__1lQlE","movieImag":"movieCard_movieImag__1khL9"};